import { render } from "./TemplateCarousel.vue?vue&type=template&id=3732d587&scoped=true"
import script from "./TemplateCarousel.vue?vue&type=script&lang=js"
export * from "./TemplateCarousel.vue?vue&type=script&lang=js"

import "./TemplateCarousel.vue?vue&type=style&index=0&id=3732d587&lang=scss&scoped=true"
import "./TemplateCarousel.vue?vue&type=style&index=1&id=3732d587&lang=scss"
script.render = render
script.__scopeId = "data-v-3732d587"

export default script